<template>
  <scroll-tracker>
    <v-app>
      <application-notifications />
      <vue-announcer />
      <router-view />
      <cookie-notice
        :header-text="$t('cookie.header')"
        :description-text="$t('cookie.description')"
        :description-link-text="$t('cookie.descriptionLink')"
        :acknowledge-text="$t('cookie.acknowledge')"
        :dismiss-text="$t('cookie.dismiss')"
      />
    </v-app>
  </scroll-tracker>
</template>

<script>
import ScrollTracker from '@/components/analytics/ScrollTracker'
import ApplicationNotifications from '@/components/notifications/ApplicationNotifications'
import ServiceRegistry from '@/service/registry/ServiceRegistry'
import { CookieNotice } from '@tangocard/mango'

export default {
  name: 'App',
  components: {
    ApplicationNotifications,
    CookieNotice,
    ScrollTracker
  },
  provide: ServiceRegistry.provideServices
}
</script>

<style lang="scss">
.grecaptcha-badge {
  visibility: hidden !important;
}
</style>
